// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TLM Kit
 *
 * Copyright © 2007-present SOHO Systems and Networks. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

:root {
  /*
   * Typography
   * ======================================================================== */

  /*
   * Layout
   * ======================================================================== */

  /*
   * Media queries breakpoints
   * ======================================================================== */  /* Extra small screen / phone */  /* Small screen / tablet */  /* Medium screen / desktop */ /* Large screen / wide desktop */
}

.Go3rc {
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
}

.hDXga {
  padding: 0 !important;
}

.iZgRb {
  padding-left: 10px;
  padding-right: 10px;
}

/* Scoped multi-column grid for the tags listing.
   NewsSideList's container class (.custom-news-side-list-container) is also
   used by NewsRead.js — these rules only fire inside .allNewsSection so the
   news-detail sidebar there isn't affected.
   Mobile keeps the existing image-left / text-right row. From 2 columns up
   the row becomes too cramped so each item becomes a card (image on top,
   text below). */

.iZgRb .custom-news-side-list-container {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  text-align: left;
  margin-top: 12px;
}

@media (min-width: 600px) {
  .iZgRb .custom-news-side-list-container {
    grid-template-columns: repeat(2, 1fr);
  }
  .iZgRb .custom-news-side-list-item img,
  .iZgRb .custom-news-side-list-item .info-section {
    display: block !important;
    width: 100% !important;
  }
  .iZgRb .custom-news-side-list-item .info-section {
    padding: 10px !important;
  }
}

@media (min-width: 900px) {
  .iZgRb .custom-news-side-list-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1400px) {
  .iZgRb .custom-news-side-list-container {
    grid-template-columns: repeat(4, 1fr);
  }
}

.ycR8H {
  font-family: Oswald, sans-serif;
  font-size: 30px;
  margin-top: 0;
  line-height: 40px;
  text-align: center;
  text-transform: uppercase;
  background-color: #0074c2;
  color: white;
}

.Zg0j9 {
  background-color: #1a72b5;
  color: white;
  width: 100px;
  border-radius: 2px;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  font-family: Oswald, sans-serif;
  margin: 0 5px 10px 0;
}

.Zg0j9:hover {
  background-color: #0078d3;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Go3rc`,
	"contentPageCustom": `hDXga`,
	"allNewsSection": `iZgRb`,
	"sectionTitle": `ycR8H`,
	"pageControlBtn": `Zg0j9`
};
module.exports = ___CSS_LOADER_EXPORT___;
